import { Alert, Form, Space, Typography } from 'antd'
import React, { useCallback, useEffect, useMemo } from 'react'
import { ToolRiskReportSupportAPI } from 'restAPI/ToolsIntegrationAPI'
import { FieldTypes, generateFormFields } from 'utils/formUtils'
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import { TOOL_RISK_SUPPORTS } from './SettingStatusConstant'
import { toolNameForAPI } from 'views/Integrations/GenericPullAndPushToolView';
import _ from 'lodash';

const ToolRiskSupport = ({ toolName, handleRiskReportChange }) => {
    const apiToolName = toolNameForAPI(toolName, true)
    const [form] = Form.useForm();
    const { globalFilterHash } = useGlobalFilterContext();

    const fetchData = useCallback(() => {
        try {
            const { promise, cancel } = ToolRiskReportSupportAPI.getToolRiskReportMapping(apiToolName);
            promise.then(resData => {
                const selectedValue = _.isEmpty(resData.config?.riskReportType) ? ['SECURITY_RISK'] : resData.config?.riskReportType
                form.setFieldsValue({ riskReport: selectedValue })
                handleRiskReportChange(selectedValue);
            })
            return cancel;
        } catch (err) {
            console.error(err)
        }
    }, [apiToolName, form, handleRiskReportChange])

    useEffect(() => {
        fetchData();
    }, [globalFilterHash, fetchData])


    const fields = useMemo(() => [{
        name: "riskReport",
        label: <Typography.Text>Select risk type to ingest.</Typography.Text>,
        placeholder: <Typography.Text>Select risk type</Typography.Text>,
        type: FieldTypes.MULTI_SELECT,
        options: parseSelectOptions(TOOL_RISK_SUPPORTS),
        colSpan: 16,
        rules: [{
            required: true,
            message: "Risk type is required."
        }],
        props: {
            allowClear: true
        }
    }], [])


    return (
        <Space direction="vertical" className="m-b-m">
            <Alert
                description={
                    <Form
                        form={form}
                        style={{ minWidth: 600 }}
                        layout="vertical"
                        onValuesChange={(values) => {
                            handleRiskReportChange(values.riskReport)
                        }}
                    >
                        {generateFormFields(fields)}
                    </Form>
                }
            />
        </Space>
    )
}

export default ToolRiskSupport

const parseSelectOptions = (options = {}) => {
    const selectOption = [];
    Object.keys(options).forEach(key => {
        selectOption.push({ label: options[key], value: key })
    })
    return selectOption;
}
